import { IFilesService } from './files.interface';

export class FilesService implements IFilesService {
  /** Получить файл.
   * @param {string} url Адрес ресурса
   * @returns {Promise<{file: Promise<Blob>, filename: string}>}
   * */
  async getFile(url: string) {
    const blob = new Blob([url], { type: 'text/plain' });

    return {
      file: Promise.resolve(blob),
      filename: url,
    };
  }
}
